module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "toggle",
    style: (_vm.mainMenuStyle),
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "toggle__btn",
    class: {
      'toggle__btn_closed': _vm.sidebarShow
    },
    style: (_vm.mainMenuStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01892570","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/toggle/Toggle.vue
// module id = 85646b9ad6f2b1924fcc
// module chunks = 89